import './App.css';
import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import { LocationProvider } from './Components/locationContext';
import Firebase from './Firebase/Firebase';
import Main from './Pages/main';
import Login from './Pages/login';
import MapShow from './Pages/mapPlaces';
import Reservation from './Pages/Reservation';
import MapAd from './Pages/mapAd';
import PrivateRoute from './Components/privateRoute';
import News from './Pages/news';
import AuthenticatedRedirectRoute from './Components/AuthenticatedRedirectRoute';
import MyProfile from './Pages/MyProfile';
import CreateCoinPackage from './Pages/CreateCoinPackage';
import CoinPurchase from './Pages/CoinPurchase';
import VerifyEmail from './Pages/VerifyEmail';
import Officemariscal from './Pages/Officemariscal';
import SalaReuniones from './Pages/sala-re';
import Space from './Pages/space';
import MapUsert from './Pages/mapUsert';
import Officerosania from './Pages/officerosania'
import Membresias from './Pages/Membresias';
import SpaceDetails from './Pages/spaceDetails';
import TypeSpace from './Pages/typeSpace';
import PageRosania from './Pages/PageRosania';
import ReservasRealizadas from './Pages/reservasRealizadas';
import SpaceMariscal from './Pages/spacesMariscal';
import Community from './Pages/community';
import EventsProximo from './Pages/eventsProximo';
import Search from './Pages/search';
import QrScanner from './Pages/Qr_eventos'
import TiposEspacios from './Pages/tipos_espacios';
import Reservasadmin from './Pages/reservasAdmin';
import Users from './Pages/users';
import Busquedas from './Pages/Busquedas';
import VerificarCoinsComprados from './Pages/verificarCoinsComprados';
import LoadingScreen from './Components/loading';
import ReservationsPage from './Pages/ReservationsPage';
import ScannerQr from './Pages/ScaneerQrAdmin';
import CrearMarca from './Pages/crearMarca';
import MarcaDetalle from './Pages/MarcaDetalle';
import PrivacyPolicy from './Components/PrivacyPolicy';
import DetalleEspacio from './Pages/PlataformaReserva';
import LugarDetalle from './Pages/LugarDetalle';
import AdministrarMarcas from './Pages/Proveedor-Marca/Administrar-Marca';
import EditarMarca from './Pages/Proveedor-Marca/ActualizarInformacionMarca';
import EditarLugar from './Pages/Proveedor-Marca/LugaresAdministracion';
import MembresiasView from './Pages/Proveedor-Marca/Membresias';
import EditarEspacio from './Pages/Proveedor-Marca/AdministrarEspacio';
import HomeLaOfi from './Pages/home';
import CoworkingPrincipal from './Pages/main';
import Servicios from './Pages/Servicios';
import BusinessProfileForm from './Pages/Servicios/ProveedorServicios/BusinessProfileForm';
import PerfilNegocioPublico from './Pages/Servicios/PerfilNegocioPublico';
import CrearServicio from './Pages/Servicios/ProveedorServicios/CrearServicio';
import ServiciosMain from './Pages/Servicios/ServiciosMain';
import ServicioDetalle from './Pages/Servicios/ServicioDetalle';
import EditarServicio from './Pages/Servicios/ProveedorServicios/EditarServicio';
import BusinessProfileView from './Pages/Servicios/PerfilNegocioPublico';
import EditarPerfil from './Pages/Servicios/ProveedorServicios/EditarPerfil';
import ExcelQRGenerator from './Components/ExcelGenerator';
import ProcesarReclamo from './Components/ProcesarReclamo';
import ReclamarCoins from './Components/ReclamarCoins';
import CoinsDashboard from './Pages/CoinDashboard';
import AutoRegisterFromExcel from './Components/AutoRegisterFromExcel ';
import ReenviarVerificaciones from './Components/Verificaciones';
import AsignarCoins from './Pages/AsignacionCoins';
import { useNavigate } from 'react-router-dom';

const auth = getAuth(Firebase);
const db = getFirestore(Firebase);
function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });


  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState('');
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      const hour = new Date().getHours();
      const isNight = hour >= 16 || hour < 6;
      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        await user.reload(); // Aseguramos que obtenemos el estado más reciente del usuario
        setUsuario(user);
        setIsEmailVerified(user.emailVerified);
        const userDocRef = doc(db, "usuarios", user.uid);
        const docSnap = await getDoc(userDocRef);
        const actualizarInfo = async (uid, userData) => {
          try {
            const userDocRef = doc(db, "usuarios", uid);
            console.log(userDocRef);
            if (userData.coinExpiration.toDate().getTime() < Date.now()) {
              console.log('Actualizando datos del usuario');
              console.log(userData.coinExpiration.toDate().getTime());
              console.log(Date.now());
              const updatedData = {
                coins: 0,  // Nuevas monedas calculadas
                coinsComprados: 0,  // Ejemplo de monedas compradas (si es necesario)

              };

              await updateDoc(userDocRef, updatedData);
            }


            console.log('Datos actualizados correctamente');
          } catch (error) {
            console.error('Error al actualizar los datos del usuario:', error);
          }
        };



        if (docSnap.exists()) {


          const userData = docSnap.data();
          actualizarInfo(user.uid, userData);

          if (user.emailVerified) {
            // Si el rol no está definido, redirigir o manejar el error
            if (!userData.role) {
              console.error('El usuario no tiene rol asignado en la base de datos');
              setRole('undefined'); // Indicamos que el rol está indefinido
            } else {
              // Asignamos el rol de la base de datos
              setRole(userData.role);
            }
          } else {
            setRole(''); // Usuario no verificado
          }
        } else {
          console.error('El documento del usuario no existe en la base de datos');
          setRole('undefined');
        }
      } else {
        setUsuario(null);
        setRole('');
        setIsEmailVerified(false);
      }
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);


  // Display loading screen while user data is being fetched
  if (loading) {
    return <LoadingScreen />;
  }


  return (
    <LocationProvider>
      <div className="App">

        <Routes>
          <Route
            path="/qr-scanner" element={<QrScanner />}
          />
          {/* Routes accessible to all users (Logged in or not) */}
          <Route path="/" element={<HomeLaOfi />} />
          <Route path="/home" element={<HomeLaOfi />} />
          <Route path="/coworking" element={<CoworkingPrincipal />} />
                    <Route path="/laofi_coworking" element={<CoworkingPrincipal />} />

          {/* <Route path="/servicios" element={<Servicios />} /> */}
<Route path="/servicios" element={<ServiciosMain />} />
          <Route path="/map" element={<MapShow />} />
<Route path="/servicios/detalle/:id" element={<ServicioDetalle />} />
          {/* Routes for non-logged-in users */}
          <Route path="/login" element={<Login />} />
          <Route
            path="/mapShow"
            element={
              !usuario ? <MapShow /> : <Navigate to="/reservation" />
            }
          />
          <Route path="/search" element={<Search />} />

          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Routes for logged-in users */}
          <Route
            path="/reservation"
            element={
              <PrivateRoute usuario={usuario}>
                <Reservation />
              </PrivateRoute>
            }
          />
          <Route path="/perfil/:uid" element={<BusinessProfileView />} />
          <Route path="/editar-perfil/:uid" element={<EditarPerfil />} />

          <Route
            path='/eventos'
            element={
              <EventsProximo />
            }
          />
          <Route
            path='/lugar/:id'
            element={
              <LugarDetalle />
            }
          />

          <Route
            path='/community'
            element={
              <Community />
            }
          />

          <Route
            path="/news"
            element={
              <PrivateRoute usuario={usuario}>
                <News />
              </PrivateRoute>
            }
          />
           <Route
            path="/asignar-coins"
            element={
              <PrivateRoute usuario={usuario} requiredRole="admin" userRole={role}>
                <AsignarCoins />
              </PrivateRoute>
            }
          />


          <Route
            path="/myprofile"
            element={
              <PrivateRoute usuario={usuario}>
                <MyProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/coin-purchase"
            element={
              <CoinPurchase />
            }
          />

          {/* Routes for administrators */}
          <Route
            path="/mapAd"
            element={
              <PrivateRoute usuario={usuario} requiredRole="admin" userRole={role}>
                <MapAd />
              </PrivateRoute>
            }
          />
          <Route
            path="/create-marca"
            element={
              <PrivateRoute usuario={usuario} requiredRole="prov" userRole={role}>
                <CrearMarca />
              </PrivateRoute>
            }
          />
          <Route
            path="/crear-servicio"
            element={
              <PrivateRoute usuario={usuario} >
                <CrearServicio />
              </PrivateRoute>
            }
          />
        <Route path="/editar-servicio/:id" element={              <PrivateRoute usuario={usuario}><EditarServicio />  </PrivateRoute>} />

          <Route path="/marca/:id" element={<MarcaDetalle />} />
          <Route
            path="/Reservas_Admin"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin", "prov"]}>
                <Reservasadmin />
              </PrivateRoute>
            }
          />

          <Route
            path="/create-coin-package"
            element={
              <PrivateRoute usuario={usuario} requiredRole="admin" userRole={role}>
                <CreateCoinPackage />
              </PrivateRoute>
            }
          />
          <Route
            path="/qr-scan"
            element={
              <PrivateRoute usuario={usuario} requiredRole="admin" userRole={role}>
                <ScannerQr />
              </PrivateRoute>
            }
          />
          <Route
            path="/verficarCoinsComprados"
            element={
              <PrivateRoute usuario={usuario} requiredRole="admin" userRole={role}>
                <VerificarCoinsComprados />
              </PrivateRoute>
            }
          />


          <Route
            path="/office_mariscal"
            element={
              <Officemariscal />
            }
          />
          <Route
            path="/sala_de_reuniones"
            element={
              <PrivateRoute usuario={usuario}>
                <SalaReuniones />
              </PrivateRoute>
            }
          />
          <Route

            path="/office/:IdEspacio"
            element={

              <DetalleEspacio />
              //<Officerosania />

            }
          />
          <Route

            path="/politica-de-privacidad"
            element={
              <PrivacyPolicy />
              //<Officerosania />

            }
          />
          <Route

            path="/crear-perfil-negocio"
            element={
              <PrivateRoute usuario={usuario}>
                <BusinessProfileForm />
              </PrivateRoute>

              //<Officerosania />

            }
          />
          <Route
            path="/tipos_espacios/:IdEspacios"
            element={
              <TiposEspacios />
            }
          />
          <Route
            path="/space"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin", "prov"]}>
                <Space />
              </PrivateRoute>
            }
          />


          <Route
            path="/portal-recargas"
            element={

              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin", "user", "prov"]}>
                <Membresias />
              </PrivateRoute>
            }
          />
          <Route
            path="/proveedor/misMarcas"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <AdministrarMarcas />

              </PrivateRoute>
            }
          />
          <Route
            path="/proveedor/marca/:id"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <EditarMarca />

              </PrivateRoute>
            }
          />

          <Route
            path="/proveedor/marca/:idMarca/lugar/:idLugar"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <EditarLugar />
              </PrivateRoute>
            }
          />
          <Route
            path="/proveedor/membresias/:id"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <EditarMarca />

              </PrivateRoute>
            }
          />
          <Route
            path="/proveedor/marca/:idMarca/lugar/:idLugar/membresias"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <MembresiasView />
              </PrivateRoute>
            }
          />
          <Route
            path="/proveedor/marca/:idMarca/lugar/:idLugar/espacio/:idEspacio"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["prov", "user", "admin"]}>
                <EditarEspacio />
              </PrivateRoute>
            }
          />
          <Route
            path="/mapUsert"
            element={
              <MapUsert />
            }
          />
          <Route
            path="/SpaceDetails"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin", "prov"]}>
                <SpaceDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/TypeSpace"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin"]}>
                <TypeSpace />
              </PrivateRoute>
            }
          />
          <Route
            path="/PageRosania"
            element={
              <PageRosania />
            }
          />
           <Route
            path="/generadorQr"
            element={
              <ExcelQRGenerator />
            }
          />
             <Route
            path="/procesar-reclamo"
            element={
              <ProcesarReclamo />
            }
          />
          
          <Route
            path="/qr-card-coins"
            element={
              <ReclamarCoins />
            }
          />
          <Route
            path="/registerExcel"
            element={
              <AutoRegisterFromExcel />
            }
          />
          <Route
            path="/verificacionesExcel"
            element={
              <ReenviarVerificaciones />
            }
          />
          <Route
            path="/reservasRealizadas"
            element={
              <PrivateRoute usuario={usuario}>
                <ReservasRealizadas />
              </PrivateRoute>
            }
          />
          <Route

            path="/spaceMariscal"
            element={
              <SpaceMariscal />
            }
          />
          <Route

            path="/wallet"
            element={
              <CoinsDashboard />
            }
          />

          <Route

            path="/users"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin", "prov"]}>
                <Users />
              </PrivateRoute>
            }
          />
          <Route

            path="/Busquedas"
            element={
              <PrivateRoute usuario={usuario} userRole={role} requiredRole={["admin"]}>
                <Busquedas />
              </PrivateRoute>
            }
          />


          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </LocationProvider>
  );
}

export default App;
